import {
  Plus,
  PlusCircle,
  Books,
  Trash,
  PencilSimple,
  ArrowSquareOut,
  FacebookLogo,
  Image,
  InstagramLogo,
  Book,
  LinkedinLogo,
  List,
  LockSimple,
  Globe,
  X,
  XCircle,
  MagnifyingGlass,
  SnapchatLogo,
  ChatCircleDots,
  TwitterLogo,
  UserCircle,
  DotsSix,
  Eye,
  FileMagnifyingGlass,
  Warning
} from '@phosphor-icons/react'


const WikipediaIcon = ({ className = '', size, ...props }) => (
  <span className={`icon ${className}`} style={{ fontSize: size }} {...props}>W</span>
)


export const icons = {
  add: Plus,
  addCircle: PlusCircle,
  courses: Books,
  delete: Trash,
  edit: PencilSimple,
  externalLink: ArrowSquareOut,
  facebook: FacebookLogo,
  image: Image,
  instagram: InstagramLogo,
  lessons: Book,
  linkedin: LinkedinLogo,
  menu: List,
  private: LockSimple,
  public: Globe,
  remove: X,
  removeCircle: XCircle,
  search: MagnifyingGlass,
  snapchat: SnapchatLogo,
  topics: ChatCircleDots,
  twitter: TwitterLogo,
  userCircle: UserCircle,
  fileSearch: FileMagnifyingGlass,
  verticalDragHandle: DotsSix,
  view: Eye,
  warningTriangle: Warning,
  wikipedia: WikipediaIcon,
}


export const Icon = ({ icon: IconComponent, className = '', ...props }) => (
  <IconComponent className={`icon ${className}`} {...props} />
)
